<template>
  <div
    class="good_card_warp"
    @mouseenter="handleMouseEnterAndChangeHover"
    @mouseleave="handleMouseLeaveAndChangeHover"
    @click="showGoodDetailDialog(info.no)"
  >
    <div class="good_card_content">
      <div :class="imgClassObject" class="good_img_content">
        <img
          :src="`http://www.00800.com.cn/source/wqproject/data/upload/${info.image}`"
          style="width:100%"
        />
        <div class="subtitle">{{info.name2}}</div>
      </div>
      <div class="good_desc">
        <div class="good_price">￥{{info.price ==undefined?'暂无数据':info.price.price}}</div>
        <!-- <div class="good_sales">月销38笔</div> -->
        <div class="good_name" v-if="showDetail">{{info.name}}</div>
        <div class="good_other" v-if="showDetail">
          <!-- <md-button @click="showHoverContext=true">评价</md-button>
          <md-button>收藏</md-button>-->
        </div>
      </div>
    </div>
    <!-- <transition
      name="custom-classes-transition"
      enter-active-class="animated fadeInUp"
      leave-active-class="animated fadeOutDown"
    >
      <div
        class="good_card_detail"
        v-show="showHoverContext&&hoverRemain"
      >
        <div class="good_card_detail_desc">
        </div>
        <div class="good_card_detail_action">
          <md-button class="md-dense md-raised md-primary" @click="showGoodDetailDialog(info.no)">查看详情</md-button>
          <md-button class="md-dense md-raised md-accent" @click="addToShoppingCart">加入购物车</md-button>
        </div>
      </div>
    </transition>-->
    <!-- <md-dialog :md-active.sync="showDialog" style="width:70%;height:97vh;max-height:100%;">
      <iframe :src="`http://www.00800.com.cn/cnhs/wqproject/index.php?app=public&mod=Sale&act=goods_detail&no=${detialNo}`" style="height:100%">
      </iframe>
      

  
    </md-dialog>-->
    <el-dialog
      :visible.sync="showDialog"
      custom-class="dialogClass"
      :append-to-body="true"
    >
      <iframe
        :src="`http://www.00800.com.cn/cnhs/wqproject/index.php?app=public&mod=Sale&act=goods_detail&no=${detialNo}`"
        style="height:100%;width:100%"
      ></iframe>
    </el-dialog>
    
  </div>
</template>
<script>
// import Adv from '@/components/Adv/index'
export default {
  // components:{
  //   Adv
  // },
  props: {
    showDetail: {
      type: Boolean,
      required: false,
      default: true
    },
    info: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      showHoverContext: false,
      hoverRemain: false,
      hoverTimer: null,
      showDialog: false,
      detialNo: ""
    };
  },
  computed: {
    imgClassObject() {
      return {
        good_img: this.showDetail,
        good_img_without_detail: !this.showDetail
      };
    }
  },
  methods: {
    showGoodDetailDialog(no) {
      this.detialNo = no;
      this.showDialog = true;
    },
    //防止滚动过快弹出详细框
    handleMouseEnterAndChangeHover() {
      this.showHoverContext = true;
      this.hoverTimer = setTimeout(() => {
        this.hoverRemain = true;
      }, 500);
    },
    handleMouseLeaveAndChangeHover() {
      this.showHoverContext = false;
      this.hoverRemain = false;
      clearTimeout(this.hoverTimer);
    },
    //加入购物车
    addToShoppingCart() {
      if (this.$store.state.isLogin) {
        //登录情况
      } else {
        //未登录情况
      }
      this.$router.push({ path: "/goods", query: { no: this.info.no } });
    }
  }
};
</script>
<style lang="scss">
.dialogClass {
  width: 70%;
  height: 90vh;
  max-height: 100%;
  margin-top: 5vh!important;
  .el-dialog__headerbtn{

  }
  .el-dialog__header{
    height:0;
    padding: 0;
  }
  .el-dialog__body{
    padding: 0;
    width: 100%;
    height: 100%;
  }
}
</style>

<style lang="scss" scoped>
.adv{
  position: fixed;
  right: 0;
}
$topicColor: rgba(51, 204, 153, 0.9);

.good_card_warp {
  cursor: pointer;
  display: flex;
  border: 1px solid #e7e7e7;
  width: 100%;
  min-width: 275px;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  position: relative;
  text-align: left;
  overflow: hidden;
  .good_card_content {
    z-index: 1;
    width: 100%;
    .good_img_content {
      position: relative;
      .subtitle {
        position: absolute;
        left: 0;
        bottom: 0;
        z-index: 2;
        width: 100%;
        min-height: 35px;
        line-height: 1.25rem;
        padding: 5px 0.5rem;
        font-size: 0.75rem;
        background: rgba(0, 0, 0, 0.4);
        color: #e1e1e1;
        box-sizing: border-box;
      }
    }
    .good_img {
      width: 100%;
      height: calc(100% - 135px);
      img {
        width: 100%;
        height: 100%;
      }
    }
    .good_img_without_detail {
      width: 100%;
      height: calc(100% - 50px);
      overflow: hidden;
    }
    .good_desc {
      .good_price {
        margin-top: 10px;
        font-weight: bold;
        font-size: 14px;
        color: #ff3d3d;
      }
      .good_sales {
        color: #919191;
      }
      .good_name {
        height: 30px;
        line-height: 30px;
        font-size: 18px;
        margin-top: 5px;
        overflow: hidden;
      }
      .good_other {
        display: flex;
        justify-content: center;
      }
    }
  }
  .good_card_detail {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: $topicColor;
    z-index: 2;
    .good_card_detail_desc {
    }
    .good_card_detail_action {
      background: #fff;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100px;
      display: flex;
      align-items: center;
      padding: 20px;
      justify-content: space-between;
      border: 1px solid $topicColor;
    }
  }
  // &:hover .good_card_detail {
  //   display: block;
  // }
}
</style>
